<template>
  <div>
    <div class="col-12 col-md-4">
      <base-select v-model="form.currFileType"
                   :options="form.fileTypeOptions"
                   label="File Type">
      </base-select>
    </div>
    <div class="col-12 col-md-6">
      <base-file-uploader v-model="form.existingFile"
                          :file="form.existingFile"
                          label="File Upload" />
    </div>
    <div class="col-12 col-md-2" style="margin-top: 2.8%;">
      <button class="btn btn-success" @click="addFile">
        Add File
      </button>
    </div>
    <div class="col-12 col-md-12" v-if="form.fileList.length > 0">
      <p class="upload-header" style="font-size: 16px; font-weight: bold;"> Uploaded Documents </p>
      <p style="font-size: 16px;">* A Site Map is required for all equipment registrations</p>
    </div>
    <div class="col-12 col-md-12" v-if="form.fileList.length > 0">
      <div class="file-upload-separator" style="margin-top: 0%;"></div>
    </div>
    <div class="col-12 col-md-12 m-l-1" v-for="(file, index) in form.fileList">
        <div class="col-12 col-md-6" style="margin-top: 2%;">
          <h5 class="file-name" style="width: 100%; float: left; font-size: 1rem;">
            {{file.name}} ({{form.fileTypes[index]}})
          </h5>
        </div>
        <div class="col-12 col-md-6">
          <div class="progress" style="width: 50%; height: 30px; float: left">
            <div class="progress-bar statusbar"
                 :class="[(form.fileList[index].scanStatus == 0 ? 'progress-bar-striped progress-bar-animated bg-primary' : ''), (form.fileList[index].scanStatus == 1 ? 'progress-bar-striped progress-bar-animated bg-warning' : ''), (form.fileList[index].scanStatus == 2 ? 'bg-success' : '')]"
                 role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
              <span class="filestatus"> Uploading... </span>
            </div>
          </div>
          <button @click="removeFile(index)" class="btn btn-primary removeBtn" style="height: 30px; font-size: 0.75em; margin-left: 10px; float: left;" :disabled="form.fileList[index].id == undefined">
            Remove File
          </button>
      </div>
    </div>
    <div class="col-12 col-md-12" v-if="form.fileList.length > 0">
      <div class="file-upload-separator" style="margin-bottom: 3%;"> </div>
    </div>
    <button @click="goToCheckout" class="btn btn-success eDetailElement upload-checkoutbtn" :disabled="form.scanning > 0">
      Proceed to Checkout
    </button>
  </div>
</template>

<script>
import { uploadFile, getFileRequestId, getFileStatuses, removeFile, errorNotification } from '@/js/FormFunctions';
import BaseInput from '@/components/BaseInput';
import BaseSelect from '@/components/BaseSelect';
import BaseFileUploader from '@/components/BaseFileUploader';
import BaseTextarea from '@/components/BaseTexarea';

export default {
  name: 'EquipmentFileUpload',
  components: {
    BaseInput, BaseSelect, BaseFileUploader, BaseTextarea,
  },
  data() {
    return {
      form: this.$parent.form,
      fileType: null,
      readySize: 0,
      file: null,
      scanInterval: null,
      scanning: 0,
      running: false,
    };
  },
  mounted() {
    this.updateUploadStatus();
  },
  validations: {

  },
  methods: {
    addFile() {
      const vm = this;
      if (this.form.existingFile != null && this.form.currFileType != null) {
        if (this.form.fileRequestId == null) {
          getFileRequestId()
            .then((data) => {
              vm.form.fileRequestId = data.data;
              this.uploadFile();
            })
            .catch((error) => {
            });
        } else {
          this.uploadFile();
        }
      }
    },
    removeFile(index) {
      const id = this.form.fileList[index].id;

      const vm = this;
      const readyIndex = this.form.readyList.map(e => e.id).indexOf(id);
      removeFile(id)
        .then((data) => {
          vm.form.readyList.splice(readyIndex, 1);
          vm.form.fileList.splice(index, 1);
          vm.form.fileTypes.splice(index, 1);
        })
        .catch((error) => {

        });
    },
    uploadFile() {
      this.$set(this.form.existingFile, 'scanStatus', 0);
      this.form.fileList.push(this.form.existingFile);
      this.form.fileTypes.push(this.form.currFileType);
      const eF = this.form.existingFile;
      const cFT = this.form.currFileType;
      this.form.existingFile = null;
      this.form.currFileType = null;
      this.form.scanning++;
      const index = this.form.fileList.length - 1;
      const vm = this;
      uploadFile(eF, this.$attrs.siteNumber, this.form.fileRequestId, cFT)
        .then((data) => {
        })

        .catch((error) => {
          this.$notify('Error uploading file', 'error');
          vm.form.fileList.splice(index, 1);
          vm.form.fileTypes.splice(index, 1);
          this.form.scanning--;
        });
    },
    updateUploadStatus() {
      const vm = this;
      if (this.form.fileRequestId == null) {
        return;
      }
      this.running = true;
      getFileStatuses(this.form.fileRequestId)
        .then((data) => {
          let adjusted = 0;

          for (let i = 0; i < data.data.length; i++) {
            if (data.data[i].scanStatus == 1) {
              document.getElementsByClassName('filestatus')[adjusted].innerText = 'Scanning...';
              vm.$set(vm.form.fileList[i], 'scanStatus', 1);
              vm.$forceUpdate();
              adjusted++;
            } else if (data.data[i].scanStatus == 2) {
              if (vm.form.readyList.map(e => e.id).indexOf(data.data[i].id) < 0) {
                vm.setToComplete(adjusted);
                vm.form.readyList.push(data.data[i]);
                vm.form.fileList[i].id = data.data[i].id;
                vm.form.fileList[i].scanStatus = 2;
                vm.$forceUpdate();
              }
              adjusted++;
            } else if (data.data[i].scanStatus == 3) {
              const self = vm;
              vm.form.fileList.splice(adjusted, 1);
              vm.form.fileTypes.splice(adjusted, 1);
              removeFile(data.data[i].id)
                .then((res) => {
                  errorNotification(`File scanning failed for: ${res.data}`, 'error');
                });
            }
          }
        })
        .catch((error) => {

        });
      this.running = false;
    },
    setToComplete(adjusted) {
      document.getElementsByClassName('filestatus')[adjusted].innerText = 'Scan Complete';

      if (this.form.scanning > 0) {
        this.form.scanning--;
      }
    },
    goToCheckout() {
      this.$router.push({ name: 'AddEquipmentReviewChanges', query: this.$route.query });
    },
    checkReadyFiles(file) {
      for (let i = 0; i < this.form.readyList.length; i++) {
        if (this.form.readyList[i] === file) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    'form.scanning': function () {
      if (this.form.scanning == 0) {
        clearInterval(this.scanInterval);
      } else {
        this.scanInterval = setInterval(() => {
          this.updateUploadStatus();
        }, 7500);
      }
    },
  },
};

</script>
